import Step from "../../models/Step";
import { requestFactory } from "@socotec.io/socio-vue-components";
import { setDisplayedItems } from "@/utils/setDisplayedItems";
import { list, listAll, retrieve } from "@/utils/factoryRest";
import { StepApi } from "@socotec.io/certipers-back-sdk";
import configs from "@/setup/openApiConfig";
import { defineStore } from "pinia";
import { useRepo } from "pinia-orm";

const stepsRepo = useRepo(Step);
const stepApi = new StepApi(configs.certipersBackConfig);

export const formatStep = (step) => {
  return {
    ...step,
    cycleUuid: step.cycle,
  };
};

export const useStepStore = defineStore("step", {
  state: () => ({
    stepsCount: 0,
  }),

  actions: {
    fetchSteps: list({
      ModelRepo: stepsRepo,
      restListMethod: stepApi.list.bind(stepApi),
      handleResponseData: ({ results }) => {
        return results.map(formatStep);
      },
      onItemsInserted: (responseData) => {
        setDisplayedItems(stepsRepo, responseData.results);
        useStepStore().setStepsCount(responseData.count);
      },
    }),

    async fetchAllSteps({ filters = {} } = {}) {
      const results = await listAll(stepApi.list.bind(stepApi), filters);

      this.setStepsCount(results.length);
      const steps = stepsRepo.save(results.map(formatStep));
      setDisplayedItems(stepsRepo, results);

      return steps;
    },

    retrieveStep: retrieve({
      ModelRepo: stepsRepo,
      restRetrieveMethod: stepApi.retrieve.bind(stepApi),
      handleResponseData: (response) => {
        return formatStep(response);
      },
    }),

    setStepsCount(count) {
      this.stepsCount = count;
    },
  },

  getters: {
    getStepsCount: (state) => state.stepsCount,
    getSteps: () => {
      return requestFactory.getters.paginateGetter(
        stepsRepo.orderBy("createdAt", "desc").withAll(),
      );
    },
    getStepDisplayed: () => {
      return stepsRepo.where("isDisplayed", true).with("examinationsList").first();
    },
  },
});
